import {useContext} from 'react'
import Button from './Button'
import './PrevNext.sass'
import { ProductContext } from '../Context/Context'

const PrevNext = (props) => {

	const {
		activeStep,
		setActiveStep,
		step,
		setStep,
	} = useContext(ProductContext)


	const setStepHandler = (s) => { 
		
		if (s === -1) {
			setStep(prev => prev - 1)

		} else { 

			if (step === activeStep) {
				setActiveStep(step + 1)
				setStep(step + 1)
			}

			if (step < activeStep) { 
				setStep(step + 1)
			}
		}

	}



	return (
		<div className="no__nav-buttons">
			{step > 1 && <div onClick={() => setStepHandler(-1)} className="no__primary fixed__button back__button" >Zurück</div>}
			<Button click={() => setStepHandler(1)} title="Weiter" disabled={props.disabled} className="no__primary fixed__button" />
		</div>
	)
}

export default PrevNext
